<template>
  <div class="row d-flex justify-content-center align-items-center">
    <div
      class="upload-card col-10 col-md-5 col-lg-4 rounded flex-col px-4 pb-2"
    >
      <div class="row d-flex justify-content-start page-header">
        <span class="col p-0"
          >Upload {{ formType === "mastering" ? "track" : "files" }}</span
        >
      </div>

      <div class="row">
        <div
          v-if="xhrErrorMainForm"
          class="alert alert-danger w-100 px-2 py-1"
          role="alert"
        >
          {{ xhrErrorMainForm }}
        </div>
      </div>

      <div class="row mt-1 d-flex justify-content-end">
        <div class="col-12 d-flex justify-content-end">
          {{ credits }}
        </div>
      </div>
      <div class="row form-switcher" :class="formSwitcherClass">
        <div class="col" @click="switchForm('stereo')">
          Full Stem <span class="d-none d-md-block"> Mix</span>
        </div>
        <div class="col" @click="switchForm('track')">
          2 Track <span class="d-none d-md-block"> Mix</span>
        </div>
        <div class="col" @click="switchForm('atmos')">
          Atmos <span class="d-none d-md-block"> Mix</span>
        </div>
        <div class="col" @click="switchForm('mastering')">
          Master
        </div>
      </div>

      <div v-if="formType !== 'mastering'" class="row mt-3">
        <div class="col-12 mt-2 select-project-header">
          Select a Project <span v-if="!assignProject">or add a </span>
          <span
            v-else
            @click="assignProject = !assignProject"
            class="new-project-btn"
            >cancel
          </span>
          <span
            v-if="!assignProject"
            @click="assignProject = !assignProject"
            class="new-project-btn"
            >new project</span
          >
        </div>
        <div v-if="assignProject" class="col-12 mt-2 mb-0">
          <div class="input-group create-project">
            <input
              ref="projectSelect"
              type="text"
              class="form-control"
              placeholder="Enter new project's name"
              v-model="newProjectName"
            />
            <div class="input-group-append">
              <button
                @click="createProject"
                class="btn btn-outline-secondary"
                type="button"
                :disabled="!newProjectName"
              >
                <span v-if="submittingNewProject">
                  <div
                    class="spinner-border spinner-border-sm text-light"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </span>

                <span v-else>
                  Create Project
                </span>
              </button>
            </div>
          </div>
        </div>
        <div v-if="assignProject" class="col-12 create-project-error">
          Failed to create project.
        </div>
        <div class="col-12 mt-2">
          <div class="input-group mt-1">
            <select
              v-model="selectedProject"
              class="custom-select"
              id="inputGroupSelect04"
              aria-label="Example select with button addon"
            >
              <option value="null">No Project</option>
              <option
                v-for="item in [...apiEvents.userProjects].reverse()"
                :key="item.id"
                :value="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <NewFileDropZone
            :type="addRefUrls ? 'ref' : 'track'"
            :acceptFile="acceptedFiles"
            :multiple="allowMultipleFileUpload"
          />
        </div>
      </div>

      <div
        v-if="formType !== 'mastering'"
        class="row d-flex justify-content-end add-reference"
      >
        <div class="col-6">
          <ul v-if="requiredFiles.length > 0">
            <li v-for="(item, index) in requiredFiles" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="col-6 d-flex justify-content-end">
          <button @click="toggleRefUrls">
            Add {{ addRefUrls ? "tracks" : "reference tracks" }} +
          </button>
        </div>
      </div>

      <div class="row">
        <input
          tabindex="0"
          class="mt-3 song-name"
          type="text"
          placeholder="Enter Song name..."
          @input="onNameChange"
        />
      </div>

      <div v-if="files.length > 0" class="row added-tracks-label my-2">
        <span class="col p-0">Added Tracks ({{ files.length }})</span>
      </div>

      <div
        class="added-tracks-container row"
        v-for="item in files"
        v-bind:key="item.id"
      >
        <div class="col-1">
          <img
            class="m-1 mr-3"
            src="../assets/folder.png"
            height="25"
            width="25"
            alt="folder"
          />
        </div>
        <div class="col">
          <p class="mb-0">{{ item.file.name }}</p>
          <div class="sub-text d-flex align-items-end">
            <p class="pr-4">{{ (item.file.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
        <div class="col-1">
          <img
            class="m-1 remove-file-btn"
            src="../assets/trash.png"
            height="20"
            width="20"
            alt="status"
            @click="removeFile(item.file.name)"
          />
        </div>
      </div>

      <div v-if="refFiles.length > 0" class="row added-tracks-label my-2">
        <span class="col p-0">Reference Tracks ({{ refFiles.length }})</span>
      </div>

      <div
        class="added-tracks-container row"
        v-for="item in refFiles"
        v-bind:key="item.id"
      >
        <div class="col-1">
          <img
            class="m-1 mr-3"
            src="../assets/folder.png"
            height="25"
            width="25"
            alt="folder"
          />
        </div>
        <div class="col">
          <p class="mb-0">{{ item.file.name }}</p>
          <div class="sub-text d-flex align-items-end">
            <p class="pr-4">{{ (item.file.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
        <div class="col-1">
          <img
            class="m-1 remove-file-btn"
            src="../assets/trash.png"
            height="20"
            width="20"
            alt="status"
            @click="removeFile(item.file.name)"
          />
        </div>
      </div>

      <div class="row d-flex justify-content-end mt-4">
        <div class="col-12">
          <button
            :disabled="
              isSubmittingForm ||
                isSubmitButtonsDisabled ||
                isCheckingCredit ||
                fileUploading
            "
            class="w-100 submit-btn py-2"
            @click="onSubmit"
            style="--width: var(
            '100%'
          )"
          >
            {{
              !isSubmittingForm && !isCheckingCredit
                ? "Submit"
                : submitButtonLoadingText
            }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="noCreditConfirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="noCreditConfirmModal"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto pr-0 d-flex">
                <h2 class="category-title">
                  {{ getCategoryTitle(this.formType) }}
                </h2>
              </div>
            </div>
            <div>
              <h2>{{ songName }}</h2>
            </div>
            <div class="confirm-modal-message">
              <span>
                This will require <b>1</b> credit of
                <b>{{ getCategoryTitle(this.formType) }} </b>. A new tab will
                open for <b>{{ getCategoryTitle(this.formType) }} </b>credit
                purchase. Would you like to continue?
              </span>
            </div>

            <div v-if="isSubmittingForm" class="row px-3">
              <div class="col-12">
                <div class="progress">
                  <div
                    class="progress-done"
                    :style="{
                      width: loadingProgress
                    }"
                  >
                    <span class="ml-4">
                      {{ loadingProgress }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row confirm-modal-footer d-flex justify-content-between mt-2 px-3"
            >
              <button
                class="col-4 cancel-btn w-100 d-flex justify-content-start"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                :disabled="
                  isSubmittingForm ||
                    isSubmitButtonsDisabled ||
                    isCheckingCredit ||
                    fileUploading
                "
                @click="onUpload"
                class="col-8 confirm-btn w-100"
              >
                Yes, continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="creditConfirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="creditConfirmModal"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto pr-0 d-flex">
                <h2 class="category-title">
                  {{ getCategoryTitle(this.formType) }}
                </h2>
              </div>
            </div>
            <div>
              <h2>{{ songName }}</h2>
            </div>
            <div class="confirm-modal-message">
              <span>
                This will use <b>1</b> credit of
                <b>{{ getCategoryTitle(this.formType) }} </b>. Would you like to
                continue?
              </span>
            </div>

            <div v-if="isSubmittingForm" class="row px-3">
              <div class="col-12">
                <div class="progress">
                  <div
                    class="progress-done"
                    :style="{
                      width: loadingProgress
                    }"
                  >
                    <span class="ml-4">
                      {{ loadingProgress }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row confirm-modal-footer d-flex justify-content-between mt-2 px-3"
            >
              <button
                class="col-4 cancel-btn w-100 d-flex justify-content-start"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                :disabled="
                  isSubmittingForm ||
                    isSubmitButtonsDisabled ||
                    isCheckingCredit
                "
                @click="onUpload"
                class="col-8 confirm-btn w-100"
              >
                Yes, create project
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadContainer from "../components/UploadContainer.vue";
import NewFileDropZone from "../components/NewFileDropZone.vue";
import { mapState } from "vuex";
import { stringHasSpecialCharacters } from "@/utils/string-utils";
import axios from "axios";
import { createNewProject } from "../services/projects";
import { getUserCredits } from "../services/credits";

const creditsKeyPair = {
  stereo: "sqty",
  track: "mqty",
  atmos: "aqty",
  mastering: "mstqty"
};

const categoryTitleKeyPair = {
  stereo: "Full Stem Mix",
  track: "2 Track Mix",
  atmos: "Atmos Mix",
  mastering: "Master"
};

export default {
  components: {
    NewFileDropZone,
    UploadContainer
  },
  mounted() {
    this.$route.params.cat ? (localStorage.cat = this.$route.params.cat) : "";
    this.$store.dispatch("apiEvents/fetchActiveGroups", {
      isSimple: this.isSimple,
      trackCategory: localStorage.cat
    });
  },
  data() {
    return {
      catg: this.$route.params.cat ? this.$route.params.cat : localStorage.cat,
      formType: this.$route.params.cat ? this.$route.params.cat : "stereo",
      files: [],
      refFiles: [],
      songName: null,
      trackUrls: [],
      refUrls: [],
      selectedProject: "",
      addRefUrls: false,
      progressValue: 0,
      isSubmittingForm: false,
      isCheckingCredit: false,
      fileUploading: null,
      selectedProject: null,
      newProjectName: null,
      assignProject: false,
      submittingNewProject: false,
      xhrErrorMainForm: null,
      xhrErrorCreateProject: null
    };
  },
  watch: {
    "$store.state.trackData.currentDataList": function() {
      this.files = this.$store.state.trackData.currentDataList;
    },
    "$store.state.trackData.currentRefList": function() {
      this.refFiles = this.$store.state.trackData.currentRefList;
    },
    formType: function() {
      if (this.formType === "mastering") {
        this.$store.dispatch("trackData/clearRefFile");
        this.addRefUrls = false;
      }
    }
  },
  computed: {
    ...mapState(["apiEvents"], ["trackData"]),
    submitButtonLoadingText() {
      if (this.isCheckingCredit) {
        return "Checking credit...";
      }

      if (this.fileUploading && this.fileUploading === "track") {
        return "Uploading track files...";
      }

      if (this.fileUploading && this.fileUploading !== "track")
        return "Uploading reference files";
    },
    isSimple() {
      // return this.$store.state.trackData.trackStyle == "Simple" ? true : false;
      return false;
    },
    requiredFiles() {
      let f = [];

      if (this.$store.state.trackData.currentRefList.length === 0) {
        f.push("Add atleast 1 reference track");
      }

      if (this.$store.state.trackData.currentDataList.length === 0) {
        f.push("Add atleast 1 track");
      }
      return f;
    },
    isSubmitButtonsDisabled() {
      if (this.formType === "mastering") {
        return (
          (!this.songName && this.songName !== "") ||
          (!this.$store.state.trackData.currentDataList.length === 0 &&
            this.$store.state.trackData.currentRefList.length === 0)
        );
      } else {
        return (
          (!this.songName && this.songName !== "") ||
          !this.$store.state.trackData.currentDataList.length === 0 ||
          this.$store.state.trackData.currentRefList.length === 0
        );
      }
    },
    loadingProgress() {
      return `${this.progressValue}%`;
    },
    formSwitcherClass() {
      switch (this.formType) {
        case "stereo":
          return {
            first: true
          };

        case "track":
          return {
            second: true
          };

        case "atmos":
          return {
            third: true
          };

        case "mastering":
          return {
            fourth: true
          };
      }
    },
    allowMultipleFileUpload() {
      return this.formType !== "mastering";
    },
    acceptedFiles() {
      return "audio/*, audio/x-mp3, audio/x-m4a, audio/x-wav, application/zip";
    },
    credits() {
      switch (this.formType) {
        case "stereo":
          return `${this.$store.state.apiEvents.remainingStereoMix} Full stereo mixes remaining`;

        case "track":
          return `${this.$store.state.apiEvents.remainingTracks} 2 track mixes remaining`;

        case "atmos":
          return `${this.$store.state.apiEvents.remainingAtmosMix} Atmos mixes remaining`;

        case "mastering":
          return `${this.$store.state.apiEvents.remainingMasteringMix} Master remaining`;
        default:
          return "0 Remaining";
      }
    }
  },
  methods: {
    getCategoryTitle(category) {
      return categoryTitleKeyPair[category];
    },
    onNameChange(e) {
      this.songName = e.target.value;
      if (stringHasSpecialCharacters(this.songName)) {
        this.nameError = 1;
        this.disabledbtn = 1;
        this.nameclass = "inp-danger";
        this.error = 1;
      } else {
        this.nameError = 0;
        this.disabledbtn = 0;
        this.nameclass = "n-input";
      }
    },
    switchForm(formType) {
      this.$route.params.cat = formType;
      this.formType = formType;
    },
    removeFile(name, type) {
      if (type === "ref") {
        this.$store.dispatch("trackData/removeRefFile", { fileName: name });
      } else {
        this.$store.dispatch("trackData/removeTrackFile", { fileName: name });
      }
    },
    async onUpload() {
      if (
        this.songName !== "" &&
        this.$store.state.trackData.currentDataList.length > 0
      ) {
        this.disabledbtn = 1;
        this.trackStatus = 0;
        await this.uploadS3Helper(this.songName.toString());
      } else {
        if (this.songName === "") {
          this.nameclass = "inp-danger";
          this.error = 1;
          this.disabledbtn = 0;
        }
      }
    },
    async onSubmit() {
      // Check user balance first
      this.isCheckingCredit = true;
      try {
        const { data } = await getUserCredits();
        const { userid, ...restOfCredits } = data;
        const currentCredit = restOfCredits[creditsKeyPair[this.formType]];

        if (currentCredit > 0) {
          $("#creditConfirmModal").modal(
            { backdrop: "static", keyboard: false },
            "show"
          );
        } else {
          // open confirm modal
          $("#noCreditConfirmModal").modal(
            { backdrop: "static", keyboard: false },
            "show"
          );
        }
      } catch (error) {
        this.xhrErrorMainForm = "Error occured initiating upload.";
      } finally {
        this.isCheckingCredit = false;
      }
    },
    async uploadS3Helper(trackname) {
      const trackList = this.$store.state.trackData.currentDataList;
      const trackRefList = this.$store.state.trackData.currentRefList;

      // this.$refs["progress-modal"].show();

      for (let i = 0; i < trackList.length; i++) {
        const filePathObj = await this.fileKeyPathGenerator(
          trackList[i].file,
          trackname,
          "Track"
        );
        try {
          const res = await this.generateS3Request(
            trackList[i].file,
            filePathObj.key
          );
          this.fileUploading = "track";
          await this.uploadOnUrl(res.data.signedRequest, trackList[i].file);

          this.trackUrls.push({
            stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
            stemGroup: "",
            stemName: trackList[i].file.name
          });
        } catch (error) {
          console.log(error);
          // this.$refs["progress-modal"].hide();
          await this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });

          this.uploadError = 1;
          throw "exit";
        }
      }

      if (this.formType !== "mastering") {
        this.currentUploadItem = 2;
        for (let i = 0; i < trackRefList.length; i++) {
          const filePathObj = await this.fileKeyPathGenerator(
            trackRefList[i].file,
            trackname,
            "References"
          );
          try {
            this.fileUploading = "reference";
            const res = await this.generateS3Request(
              trackRefList[i].file,
              filePathObj.key
            );
            await this.uploadOnUrl(
              res.data.signedRequest,
              trackRefList[i].file
            );

            this.refUrls.push({
              stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
              stemGroup: "",
              stemName: trackRefList[i].file.name
            });
            this.uploadError = 0;
          } catch (error) {
            this.$refs["progress-modal"].hide();
            await this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!"
            });

            this.uploadError = 1;
            throw "exit";
          }
        }
      }

      if (!this.uploadError) {
        try {
          await this.createTrackHelper();
        } catch (error) {
          console.log(error);
          throw "exit";
        }
      }
    },
    async uploadOnUrl(url, file) {
      this.timeStamp = Date.now();
      this.prevProgress = 0;
      this.progressValue = 0;
      this.isSubmittingForm = true;
      this.xhrErrorMainForm = null;
      try {
        await axios.put(url, file, {
          headers: {
            "Content-Disposition": "attachment",
            "Content-Type": file.type
          },
          maxContentLength: Infinity,
          onUploadProgress: progress => {
            let percentCompleted = Math.round(
              (progress.loaded * 100) / progress.total
            );
            let time = Date.now() - this.timeStamp;
            let percent = (percentCompleted - this.prevProgress) / 100;
            let chunk = percent * file.size;
            let speed = (chunk / 1024 / 1024 / (time / 1000)).toFixed(2);

            this.timeStamp = Date.now();
            this.prevProgress = percentCompleted;

            this.speed = speed;

            this.progressValue = percentCompleted;
          }
        });
      } catch (error) {
        if (error.response && error.response.data) {
          this.xhrErrorMainForm =
            error.response.data.message ||
            "Unexpected error occured. Contact support@getmxd.com";
        } else {
          this.xhrErrorMainForm =
            "Unexpected error occured. Contact support@getmxd.com";
        }

        throw this.xhrErrorMainForm;
      } finally {
        this.isSubmittingForm = false;
      }
    },
    formattedDate() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async fileKeyPathGenerator(file, trackName, type) {
      const date = this.formattedDate();
      const fileExt = file.name.split(".").pop();
      const path =
        localStorage.getItem("mxdUserName") +
        `_${type}_` +
        "1" +
        "_" +
        file.name
          .replace("adlib", "adlibs")
          .split("#")
          .join("_")
          .split("&")
          .join("_")
          .split("?")
          .join("_")
          .split(".")
          .slice(0, file.name.split(".").length - 1)
          .toString()
          .split(" ")
          .join("-") +
        "." +
        fileExt;

      const key =
        localStorage.getItem("mxdUserName") +
        `${type === "Track" ? "" : "/References"}/` +
        date +
        "/" +
        trackName.split(" ").join("-") +
        "/" +
        path;
      return {
        key: key,
        path: path
      };
    },
    async generateS3Request(file, key) {
      let url;
      try {
        url = await this.$store.dispatch("apiEvents/getS3Sig", {
          fileName: file.name,
          fileType: file.type,
          key: key
        });
      } catch (error) {
        throw error;
      }
      return url;
    },
    async createTrackHelper() {
      const res = await this.$store.dispatch("trackData/createNewTrack", {
        userId: parseInt(localStorage.getItem("userId")),
        trackName: this.songName.toString(),
        projectId:
          this.selectedProject && this.selectedProject != ""
            ? this.$store.state.apiEvents.userProjects.find(item => {
                return item.name === this.selectedProject;
              }).id
            : 0,
        trackCategory: this.formType,
        trackStyle: "Full",
        trackProject: this.selected,
        username: localStorage.getItem("mxdUserName"),
        trackFiles: this.trackUrls,
        refFiles: this.refUrls,
        elementGroup: this.formType
      });
      this.responseFunc(res);
    },
    async responseFunc(res) {
      if (res.data.success) {
        await this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Track Uploaded",
          showConfirmButton: false,
          timer: 1500
        });
        if (res.data.data.create_track) {
          this.$store
            .dispatch("apiEvents/fetchProjectsByUserId", {
              id: localStorage.getItem("userId")
            })
            .then(() => {
              if (this.formType === "mastering") {
                this.$router.push({
                  name: "track-master",
                  params: { id: res.data.data.create_track }
                });
              } else {
                this.$router.push({
                  name: "track",
                  params: { id: res.data.data.create_track }
                });
              }
            });
        } else {
          this.$router.push("../dashboard");
        }
        $("#creditConfirmModal").modal("hide");
        $("#noCreditConfirmModal").modal("hide");
      } else {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }
    },
    toggleRefUrls() {
      this.addRefUrls = !this.addRefUrls;
    },
    async createProject() {
      if (this.newProjectName !== "") {
        this.xhrErrorCreateProject = null;
        this.submittingNewProject = true;
        try {
          const userID = localStorage.getItem("userId");
          const f = await createNewProject(userID, this.newProjectName);
          // fetch new
          this.$store.dispatch("apiEvents/fetchProjectsByUserId", {
            id: userID
          });
          this.selectedProject = this.newProjectName;
          this.newProjectName = "";
          this.assignProject = false;
        } catch (error) {
          if (error.response && error.response.data) {
            this.xhrErrorCreateProject =
              error.response.data.message ||
              "Unexpected error occured. Contact support@getmxd.com";
          } else {
            this.xhrErrorCreateProject =
              "Unexpected error occured. Contact support@getmxd.com";
          }
        } finally {
          this.submittingNewProject = true;
        }
      } else {
        this.xhrErrorMainForm = "Song name required.";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#noCreditConfirmModal,
#creditConfirmModal {
  color: black !important;

  .category-title {
    font-family: "Poppins", sans-serif !important;
    font-weight: bold;
  }

  .cancel-btn,
  .confirm-btn {
    background: none;
    border: none;
    font-family: "Poppins", sans-serif !important;
    font-size: 24px;
    font-weight: bold;
  }

  .confirm-btn {
    background-color: #7dfcd684;
    border-radius: 20px;
  }
}

.page-header {
  font-family: "Poppins", sans-serif !important;
  font-size: 32px;
  font-weight: bold;
  text-transform: uppercase;
}

.upload-card {
  background-color: #1a1c22;
  font-family: "Poppins", sans-serif !important;
}

.form-switcher {
  position: relative;
  background-color: #63697b;
  border-radius: 1rem;

  .col {
    z-index: 1;
    display: flex;
    font-family: "Poppins", sans-serif !important;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:nth-child(1) {
      font-size: 13px;
    }
  }
}

.form-switcher::after {
  content: "";
  position: absolute;
  width: 25%;
  bottom: 0;
  transition: left cubic-bezier(0.88, -0.35, 0.565, 1.35) 0.4s,
    border-radius 0.4s ease;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
  background-color: #7dfcd684;
  height: 100%;
}

.form-switcher.first::after {
  left: 0;
  border-radius: 1rem 0rem 0rem 1rem;
}

.form-switcher.second::after {
  left: 25%;
  border-radius: 0px;
}

.form-switcher.third::after {
  left: 50%;
  border-radius: 0px;
}

.form-switcher.fourth::after {
  left: 75%;
  border-radius: 0rem 1rem 1rem 0rem;
}

.form-switcher .disabled {
  color: gray;
}

.song-name {
  font-family: "Poppins", sans-serif !important;
  background: none;
  outline: none;
  border: none;
  color: white;
  border-bottom: 1px solid grey;
  width: 100%;
}

.submit-btn {
  background-color: #7dfcd684;
  font-family: "Poppins", sans-serif !important;
  color: white;
  border-radius: 1rem;
  position: relative;
  border: none;

  &:disabled {
    color: black;
    background-color: #3b5c5284;
  }

  &:after {
    content: "";
    height: 100%;
    width: var(--width);
    top: 0;
    left: 0;
    border-radius: 1rem;
    background-color: red;
    display: flex;
    position: absolute;
  }
}

.add-reference {
  button {
    border: none;
    font-family: "Poppins", sans-serif !important;
    color: white;
    background-color: transparent;
    font-size: 12px;
  }
}

.added-tracks-label {
  span {
    font-family: "Poppins", sans-serif !important;
    font-weight: 600;
  }
}

.progress {
  background-color: #d8d8d8;
  border-radius: 20px;
  position: relative;
  margin: 15px 0;
  height: 25px;
  width: 100%;
}

.progress-done {
  font-family: "Poppins", sans-serif !important;
  background: linear-gradient(to left, #417d6b94, #7dfcd636);
  box-shadow: 0 3px 3px -5px #7dfcd684, 0 2px 5px #f2709c;
  border-radius: 10px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: 1;
  transition: 0.1s ease;
}

.custom-select {
  background-color: transparent;
  color: white;

  option {
    background: transparent;
    color: black;
  }
}

.new-project-btn {
  cursor: pointer;
  text-decoration: underline;
}

.create-project {
  input {
    color: white;
  }

  button {
    color: white;
  }
}

.create-project-error {
  color: rgb(226, 132, 132);
}

.select-project-header {
  font-family: "Poppins", sans-serif !important;
  font-weight: bold;
}

.remove-file-btn {
  cursor: pointer;
}
</style>
